import { ref, onMounted, onUnmounted } from "vue";

const voidFunction = () => {
  console.log("void");
};

export function useIdleTimer({ timeout = 0, onIdle = voidFunction } = {}) {
  const isPaused = ref(true);
  const timer = ref<number | null>(null);
  const timeoutValue = ref(timeout);

  const activityEvents = [
    "mousemove",
    "keydown",
    "click",
    "scroll",
    "touchstart",
    "touchmove",
    "touchend",
  ];

  function startTimer() {
    if (isPaused.value) return;
    stopTimer();
    timer.value = window.setTimeout(
      timeoutValue.value > 0 ? onIdle : voidFunction,
      timeoutValue.value
    );
  }

  function stopTimer() {
    if (timer.value) {
      clearTimeout(timer.value);
      timer.value = null;
    }
  }

  function resetTimer() {
    if (isPaused.value) return;
    startTimer();
  }

  function pause() {
    isPaused.value = true;
    stopTimer();
  }

  function resume() {
    if (!isPaused.value) return;
    isPaused.value = false;
    startTimer();
  }

  // ⭐ Cambiar dinámicamente el timeout desde fuera
  function setTimeoutValue(newTimeout: number) {
    timeoutValue.value = newTimeout;
    if (newTimeout === 0) return;
    startTimer();
  }

  onMounted(() => {
    activityEvents.forEach((e) =>
      window.addEventListener(e, resetTimer, { passive: true })
    );
    startTimer();
  });

  onUnmounted(() => {
    activityEvents.forEach((e) => window.removeEventListener(e, resetTimer));
    stopTimer();
  });

  return {
    pause,
    resume,
    resetTimer,
    setTimeoutValue,
    isPaused,
  };
}
